import { localisedValue } from "utils"

const leadSharingPurposesTransformer = response => {
  return response.map(e => ({ ...e, label: localisedValue({ object: e, key: "title" }), value: e.id.toString() }))
}

export default leadSharingPurposesTransformer
